export default __webpack_public_path__ + "static/ib-school-bg-1cdd4af09da7965645938c66ce93d57a.png";